// extracted by mini-css-extract-plugin
module.exports = {"logo":"navMenuStyle_logo__3zKgO"};